@defer (when helper.langLoaded()) {
  <span class="lang-switch" [@fadeTopBottom]>{{ 'switchLenguageStr' | translate }}</span>
  <button
    [@fadeTopBottom]
    class="lang-switch-btn"
    *ngFor="let translate of translates"
    mat-button
    (click)="onLangSwitch(translate.code)"
    [class.active]="(layoutService.language$ | async) === translate.code">
    <span class="lang-full-name">{{ translate.name }}</span>
    <span class="lang-label">{{ translate.label.toUpperCase() }}</span>
  </button>
} @placeholder (minimum 300ms) {
  <div class="skeleton skeleton-lang"></div>
}
